import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class TypeService extends ApiService {
  namespace = "type";
  icon = "BlueCube";
  name = "Type";
  favicon = "CubeBlue";
  window = 290;
  Width = 690;
  realm = 2;
  DOMAIN = 2;
  action = "action";
  type = "type";
  singular = this.terminology.type.singular;
  plural = this.terminology.type.plural;
  vowel = this.terminology.type.vowel;

  columns = [
    {
      header: this.t("displayName"),
      icon: "CubeBlue",
      field: "display_name",
    },
    {
      header: this.t("number"),
      icon: "Number",
      field: "number",
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit an Type",
      icon: PrimeIcons.PENCIL,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Type",
      icon: PrimeIcons.LIST,
    },
  ];
  constructor() {
    super("types");
  }
}
